import { render, staticRenderFns } from "./crm-column-settings.vue?vue&type=template&id=042d556e&"
import script from "./crm-column-settings.vue?vue&type=script&lang=js&"
export * from "./crm-column-settings.vue?vue&type=script&lang=js&"
import style0 from "./crm-column-settings.vue?vue&type=style&index=0&id=042d556e&prod&lang=css&"
import style1 from "./crm-column-settings.vue?vue&type=style&index=1&id=042d556e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports